import React from 'react'

export default function notFound(props) {
  return <div className="not-found">Sivua ei löytynyt.</div>
}
